exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sound-element-wrapper[data-v-3270c110]{padding:0 10px;cursor:pointer}", ""]);

// exports
